import {
  Textarea as ChakraTextarea,
  TextareaProps as ChakraTextareaProps,
  forwardRef,
} from "@chakra-ui/react";

/**
 * Textarea — multi-line input matching `.textarea`.
 * design ref: styles.css:833–871
 *
 * Same chrome as `.input` plus `resize: vertical`, `min-height: 72px`,
 * `line-height: 1.5`.
 */
export interface TextareaProps extends ChakraTextareaProps {}

const Textarea = forwardRef<TextareaProps, "textarea">((props, ref) => {
  return (
    <ChakraTextarea
      ref={ref}
      variant="unstyled"
      width="100%"
      display="block"
      px="md" // 12px
      py="sm" // 8px
      fontSize="md" // 14px
      fontFamily="inherit"
      color="neutral.950"
      lineHeight="1.5"
      bg="neutral.25"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="neutral.300"
      borderRadius="component.lg" // 8px
      boxShadow="xs"
      minH="72px"
      resize="vertical"
      transition="border-color 120ms, box-shadow 120ms, background-color 120ms"
      _placeholder={{ color: "neutral.500" }}
      _hover={{
        borderColor: "neutral.400",
        bg: "neutral.0",
      }}
      _focus={{
        borderColor: "p.500",
        boxShadow: "focusRing",
        outline: "none",
      }}
      _focusVisible={{
        borderColor: "p.500",
        boxShadow: "focusRing",
        outline: "none",
      }}
      _disabled={{
        bg: "neutral.100",
        color: "neutral.500",
        borderColor: "neutral.200",
        cursor: "not-allowed",
        _hover: {
          bg: "neutral.100",
          borderColor: "neutral.200",
        },
      }}
      {...props}
    />
  );
});

export default Textarea;
